import { render, staticRenderFns } from "./JdsCandidateBubbleColumnLayout.vue?vue&type=template&id=d3bce65a&scoped=true&"
import script from "./JdsCandidateBubbleColumnLayout.vue?vue&type=script&lang=ts&"
export * from "./JdsCandidateBubbleColumnLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3bce65a",
  null
  
)

export default component.exports